// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15um1","toggle":"styles_toggle__gLMJ2","preview":"styles_preview__S_ZH8"};